document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('prop-delivery');
  if (!input) return;

  // どこを押しても開く：showPicker() → フォールバックは focus()
  function openPicker(el) {
    if (!el) return;
    if (typeof el.showPicker === 'function') {
      el.showPicker();
    } else {
      el.focus(); // 古いブラウザはフォーカスで開くことが多い
    }
  }

  // 入力欄自体をクリック/フォーカスで即オープン
  // （多重発火を抑えるため pointerdown と focus の両方でハンドル）
  input.addEventListener('pointerdown', function (e) {
    // すでに開いていそうなら何もしない（必要に応じて調整）
    openPicker(input);
  });

  input.addEventListener('focus', function () {
    // タブ移動で来た時も開く（少し遅延させて誤作動防止）
    setTimeout(function(){ openPicker(input); }, 0);
  });

  // ラッパ（ラベル含む周囲）をクリックしても開く
  document.querySelectorAll('[data-role="datepicker"]').forEach(function (wrap) {
    wrap.addEventListener('click', function (e) {
      // 既に input 自体がクリックされたなら input 側のハンドラに任せる
      if (e.target !== input) openPicker(input);
    });

    // キーボード操作（Enter/Space）でも開く
    wrap.tabIndex = 0; // ヒットエリアにもフォーカス当てられるように
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openPicker(input);
      }
    });
  });
});
